import React from "react";
import "./button.css";

const Button = ({ text, onClick }) => {
  return (
    <button className="custom-button" onClick={onClick}>
      {text}
    </button>
  );
};


const NormalButton = ({ text, onClick }) => {
  return (
    <button className="normal-button" onClick={onClick}>
      {text}
    </button>
  );
};

export { Button, NormalButton };

